<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">
          <h1>{{ $static('translate.title', 'Переклади') }}</h1>
        </div>
        <div class="panel panel-bordered translates-panel">
          <!--          <div class="large-button-panel translates-button-panel bordered">-->
          <!--            <div class="files-uploader ">-->
          <!--              <div class="files-uploader-holder ">-->
          <!--                <span>Импортировать csv/xml</span>-->
          <!--              </div>-->
          <!--              <button class="waves-effect waves-light default-btn btn-gray">-->
          <!--                <span class="text">Загрузить</span>-->
          <!--              </button>-->
          <!--            </div>-->
          <!--            <button class="waves-effect waves-light default-btn btn-green btn-with-icon">-->
          <!--              <span class="text">Скачать</span>-->
          <!--              <span class="icon icon-download"></span>-->
          <!--            </button>-->
          <!--          </div>-->

          <div class="panel-heading">
            <div class="row">
              <div class="col" v-for="(lang, index) in langs" :key="index">
                <h3 style="margin-bottom:0">{{ lang.label }}:</h3>
              </div>
            </div>
          </div>

          <div class="panel-body">
            <template v-if="translate && translate.length">
              <!--<label class="custom-label mt-15 mb-20">Статичиские</label>-->
              <div class="row" v-for="(tag, index) in originKeys" :key="index">
                <!--            {{item}} {{index}}-->
                <div class="col" v-for="(lang, lIdx) in langs" :key="lIdx">
                  <div class="form-group">
                    <input type="text" class="form-control custom-input" :value="getStaticValue(lIdx, tag)"
                      @change="e => setStaticTranslate(e, lIdx, tag)">
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div style="text-align: center;margin: 0 0 40px 0;">
                <router-link class="default-btn" :to="{ 'name': 'SettingsBasic' }">
                  <span class="text">{{ $static('sb.adl', 'Додати мову') }}</span>
                </router-link>
              </div>
            </template>
          </div>

          <!--          <template v-if="translate.dynamic && translate.dynamic.original">-->
          <!--            <label class="custom-label mt-15 mb-20">Динамические</label>-->
          <!--            <div class="row" v-for="(item, index) in translate.dynamic.original" :key="index">-->
          <!--              &lt;!&ndash;            {{item}} {{index}}&ndash;&gt;-->
          <!--              <div class="col" v-for="(lang, lIdx) in langListSort" :key="lIdx">-->
          <!--                <div class="form-group">-->
          <!--                  <input type="text" class="form-control custom-input" :value="getDynamicValue(lang,index)"-->
          <!--                         @change="e => setDynamicTranslate(e, lang, index)">-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </template>-->


        </div>
        <div class="button-panel panel mt-2" v-if="translate && translate.length"
          style="position: sticky;bottom:-5px;padding-bottom:20px;  z-index: 11;">
          <button class="default-btn btn-accent" @click="save">
            <span class="text">{{ $static('translate.save', 'Зберегти зміни') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'Translate',
  components: {},
  computed: {
    settings() {
      return this.$store.getters.settings
    },
    langs() {
      return this.settings && this.settings.public && this.settings.public.lang ? this.settings.public.lang : []
    },
    originKeys() {
      return this.translate.length ? Object.keys(this.translate[0].content) : []
    },
    langList() {
      return this.translate.static ? Object.keys(this.translate.static) : []
    },
    langListSort() {
      return this.langList.map(i => this.bindSort[i] ? { id: this.bindSort[i], name: i } : { id: this.bindSort.length, name: i })
        .sort((a, b) => {
          return a.id - b.id
        }).map(i => i.name)
    },
    langListI18n() {
      return this.langListSort.map(key => this.bind[key] ? this.bind[key] : key)
    }

  },
  data() {
    return {
      translate: [],
      bind: {
        'ua': 'Украинский',
        'ru': 'Русский',
        'en': 'Английский'
      },
      bindSort: {
        'original': 1,
        'ru': 2,
        'en': 3
      },
      defaultLang: 'original'
    }
  },
  mounted() {
    this.getTranslate();
  },
  methods: {
    getTranslate() {
      api.get('/api/settings').then(response => response.data).then(data => {
        // console.log(data.public.lang);
        let fetchList = [];
        if (data.public.lang && data.public.lang.length) {
          fetchList = data.public.lang.map(i => fetch(i.value))
        }

        Promise.all(fetchList)
          .then(responseList => Promise.all(
            responseList.map(x => x.status === 200 ?
              x.json() :
              new Promise(resolve => resolve({ error: x.status }))
            ))
          ).then(list => {
            let srcList = data.public.lang;
            this.translate = [];
            list.forEach((value, index) => {
              if (value.error === undefined) {
                this.translate.push({ content: value, key: srcList[index].value });
              } else {
                this.translate.push({ content: {}, key: srcList[index].value });
              }
            })
          });
      })
    },
    save() {
      api.post('/api/translate', { translate: this.translate }).then(response => response.data).then(data => this.translate = data)
        .then(() => {
          this.$notify({
            title: this.$static('notify.translate-title', 'Переклад'),
            text: this.$static('notify.save', 'Збережено.'),
            duration: 3000
          });
        })
    },
    getStaticValue(lang, tag) {
      return this.translate[lang].content[tag] ? this.translate[lang].content[tag] : ''
    },
    setStaticTranslate(event, lang, tag) {
      if (this.translate[lang]) {
        if (Array.isArray(this.translate[lang])) {
          this.translate[lang] = {}
        }
        this.translate[lang].content[tag] = event.target.value
      }
    },
    getDynamicValue(lang, key) {
      return this.translate.dynamic[lang] ? this.translate.dynamic[lang][key] : ''
    },
    setDynamicTranslate(event, lang, key) {
      if (this.translate.dynamic[lang]) {
        if (Array.isArray(this.translate.dynamic[lang])) {
          this.translate.dynamic[lang] = {}
        }
        this.translate.dynamic[lang][key] = event.target.value
      }
    }

    // show() {
    //   window.$('#exampleModal').modal('show');
    // },
    // closeModal(){
    //   window.$('#exampleModal').modal('hide');
    // },
    // select(){
    //   window.$('#exampleModal').modal('hide');
    //   const base = this.$store.getters['fm/settings/baseUrl'];
    //   console.log(this.$store.getters['fm/selectedItems'].map(i => base + i.path).join(', '))
    // }
  }
}
</script>
